module.exports = __webpack_public_path__ + "img/FW_ShuJu.b851a953.png";